import { useQuery } from "@apollo/client/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddressFormatDocument } from "@repo/graphql/documents/address/query.generated";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { EMPTY_ADDRESS_VALUES, type AddressFormValues } from "./helpers";
import { buildAddressSchema } from "./schema";

/**
 * Form state for entering an address in `countryCode`: loads the country's
 * area levels and validates against them. Starts from `defaultValues`, e.g.
 * a saved address being edited.
 */
export default function useAddressForm(
  countryCode: string | null | undefined,
  defaultValues: AddressFormValues = EMPTY_ADDRESS_VALUES,
) {
  const { data, loading } = useQuery(AddressFormatDocument, {
    variables: { countryCode: countryCode ?? "" },
    skip: !countryCode,
  });
  const format = data?.address.addressFormat ?? null;
  const schema = useMemo(() => buildAddressSchema(format), [format]);
  const formProps = useForm<AddressFormValues>({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues,
  });
  return { formProps, format, loading };
}
